// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1UwAB","content":"LayoutSettings_content__2c5Av"};